import React from 'react'
import web2 from '../assets/web2.jpg';
import { useTranslation } from 'react-i18next';

function Home() {
    const { t } = useTranslation();

    return (
        <section className="about-section py-5" >
            <div className="container" >
                {/* Title */}
                <div className="text-center mb-5">
                    <h2 className="fw-bold">{t('homeTitle')}</h2>

                </div>
                <p className="text-muted">
                    {t('homeDescription1')}
                </p>

                <div className="row align-items-center g-5 my-4">
                    {/* LEFT CONTENT */}
                    <div className="col-md-6 m-0" data-aos="fade-right">
                        <div className="d-flex flex-column align-items-center gap-3">
                            <h6 className="fw-semibold mb-3">
                                {t('homeMotto')}
                            </h6>
                            <h6 className="fw-semibold mb-3">
                                "{t('homeMottoLine1')}
                            </h6>
                            <h6 className="fw-semibold mb-3">
                                {t('homeMottoLine2')}"
                            </h6>
                            <h6 className="fw-semibold mb-3">
                                {t('homeAdage')}
                            </h6>
                            <h6 className="fw-semibold mb-3">
                                '{t('homeGrainQuote')}'
                            </h6>
                        </div>
                    </div>

                    {/* RIGHT CARDS */}
                    <div className="col-md-6 m-0" data-aos="fade-left" data-aos-delay="200">
                        <div className="row g-4">
                            <img
                                src={web2}
                                alt="Office 2"
                                className="img-fluid rounded shadow"
                            />
                        </div>
                    </div>


                </div>
                <p className="text-muted">
                    {t('homeDescription2')}
                </p>
                <div className="text-center mt-4 w-100">
                    <span
                        className="badge fs-6 px-4 py-2 d-inline-block"
                        style={{
                            background: "#0A2158",
                            whiteSpace: "normal",
                            maxWidth: "100%",
                            lineHeight: "1.8",
                        }}
                    >
                        {t('homeAssurance')}
                    </span>
                </div>

            </div>
            {/* <div className=" text-danger py-4 px-5">
                <hr className="w-100 opacity-100" style={{ borderColor: "rgba(9, 26, 58, 1)" }} />
            </div> */}
        </section>
    );
}

export default Home